module.exports = __webpack_public_path__ + "static/media/DSC_0157.096ec224.jpg";